import * as React from 'react';

import { useEffect, useState } from 'react';
import { TABLE_CONTENT_TYPE } from 'src/commons/constants';

import { Container, Flashbar, Header, KeyValuePairs, SpaceBetween } from '@amzn/awsui-components-react-v3';
import { getMetadataForm } from 'src/api/catalog';

import { PageHeader } from 'src/components/common/PageHeader';

export interface ViewMetadataFormProps {
  setContentType: any;
  location: any;
  match: any;
  activeGroup: string;
  activeWorkspace: any;
}

const ViewMetadataForm = (props: ViewMetadataFormProps) => {
  const [metadataForm, setMetadataForm] = useState(undefined);
  const [notifications, setNotifications] = useState([]);
  const [ownerId, setOwnerId] = useState(undefined);
  const [formId, setFormId] = useState(undefined);

  useEffect(() => {
    props.setContentType(TABLE_CONTENT_TYPE);
    setOwnerId(props.match.params.formOwnerId);
    setFormId(props.match.params.id);
  }, []);

  useEffect(() => {
    if (formId && ownerId) {
      getMetadataFormForGivenId();
    }
  }, [formId, ownerId]);

  const getMetadataFormForGivenId = async () => {
    try {
      let getFormResult = await getMetadataForm({
        MetadataFormId: formId,
        OwnerId: ownerId,
      });
      setMetadataForm(getFormResult.FormDetails);
    } catch (err) {
      setNotification('error', err.message);
    }
  };

  const buttonOptions = () => {
    return [
      {
        text: '',
        icon: 'refresh',
        onItemClick: getMetadataFormForGivenId,
      },
    ];
  };

  const setNotification = async (header, message) => {
    if (header === 'success') {
      setNotifications([
        {
          type: 'success',
          content: message,
          dismissible: true,
          onDismiss: () => setNotifications([]),
        },
      ]);
    } else {
      setNotifications([
        {
          header: header,
          type: 'error',
          content: message,
          dismissible: true,
          onDismiss: () => setNotifications([]),
        },
      ]);
    }
  };

  return (
    <SpaceBetween size={'m'} direction={'vertical'}>
      <Flashbar items={notifications} />
      <PageHeader buttons={buttonOptions()} header={`Form ID: ${formId}`} />
      <Container header={<Header variant={'h2'}>Form details</Header>}>
        <KeyValuePairs
          columns={3}
          items={[
            {
              label: 'Owner',
              value: metadataForm?.OwnerId,
            },
            {
              label: 'Name',
              value: metadataForm?.Name,
            },
            {
              label: 'Description',
              value: metadataForm?.Description,
            },
            {
              label: 'Status',
              value: metadataForm?.Status,
            },
            {
              label: 'Type',
              value: metadataForm?.FormType.replace('Form#', ''),
            },
          ]}
        />
      </Container>
    </SpaceBetween>
  );
};

export default ViewMetadataForm;
